import { useDispatch } from 'react-redux';
import { setAppBusy } from 'store/actions/system';
import { removeAddress, getAccount } from 'gateways/Api';
import { setAccount } from 'store/actions/account';
import useMessages from 'hooks/useMessages';
import {
  DELETE_ADDRESS_CONFIRMATION,
  DELETE_ADDRESS_IN_USE_RESPONSE_FAILURE,
  DELETE_ADDRESS_DEFAULT_RESPONSE_FAILURE,
} from 'helpers/copyHelper';

export default () => {
  const { genericInfoMessage, genericFailureMessage } = useMessages();
  const dispatch = useDispatch();

  const defaultOnFailure = (error) => {
    if (error?.response?.data?.error?.startsWith('CLDG:420:')) {
      genericFailureMessage(DELETE_ADDRESS_IN_USE_RESPONSE_FAILURE);
    } else if (error?.response?.data?.error?.startsWith('CLDG:421:')) {
      genericFailureMessage(DELETE_ADDRESS_DEFAULT_RESPONSE_FAILURE);
    } else {
      genericFailureMessage();
    }
  };

  return ({
    address,
    onSuccess,
    onFailure = defaultOnFailure,
  }) => {
    dispatch(setAppBusy(true));
    removeAddress(address.id)
      .then(() => {
        genericInfoMessage(DELETE_ADDRESS_CONFIRMATION);
      })
      .then(() => getAccount())
      .then((updatedAccount) => dispatch(setAccount(updatedAccount)))
      .then(onSuccess)
      .catch((e) => onFailure(e))
      .finally(() => dispatch(setAppBusy(false)));
  };
};
